import { Button } from "@/components/ui/button";
import { Reveal } from "@/components/Reveal";
import CountUpNumber from "@/components/CountUpNumber";
import { useLanguage } from "@/context/LanguageContext";

export default function AboutSection() {
  const { t } = useLanguage();
  const about = t("about");
  const stats = t("trustStats") || [];

  return (
    <section id="about" data-testid="about-section" className="py-20 md:py-28 lg:py-32 bg-[#f5f0e8]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-24 items-start">
          <Reveal animation="reveal-left">
            <p className="text-[#1a5c4a] text-xs uppercase tracking-[0.3em] mb-4 font-semibold">{about.subtitle}</p>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#1a1a2e] leading-[1.1] tracking-[-0.02em] mb-8">
              {about.headline}
            </h2>
            <Button
              data-testid="about-cta"
              onClick={() => {
                const el = document.getElementById("practice-areas");
                if (el) el.scrollIntoView({ behavior: "smooth" });
              }}
              className="bg-[#1a1a2e] text-white hover:bg-[#2a2a3e] rounded-full px-8 py-5 text-sm font-medium transition-all duration-300"
            >
              {about.cta}
            </Button>
          </Reveal>

          <Reveal animation="reveal-right">
            <p className="text-[#4a4540] text-base leading-relaxed mb-6">{about.desc1}</p>
            <p className="text-[#4a4540] text-base leading-relaxed mb-10">{about.desc2}</p>
            <div data-testid="about-stats" className="grid grid-cols-3 gap-4">
              {stats.slice(0, 3).map((stat, i) => (
                <div key={stat.label} className={`${i > 0 ? "border-l border-[#d5cfc6] pl-4 lg:pl-8" : ""}`}>
                  <p className="font-heading text-2xl sm:text-3xl lg:text-5xl font-extrabold text-[#1a1a2e] mb-1 tracking-[-0.02em]">
                    <CountUpNumber target={stat.value} />
                  </p>
                  <p className="text-[#4a4540] text-xs sm:text-sm">{stat.label}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
